import _ from "lodash";
import lodash from "lodash";
import {
    ManualEntryRecordActionTypes
} from "../constants/ManualEntryRecordsActionConstants";
import MONTH_OPTIONS from "../../../common/resources/monthOptions.json";
import YEAR_OPTIONS from "../../../common/utils/yearOptions";

// set the default value of the month and year to today's running year and month.
const today = new Date();
const month = lodash.find(MONTH_OPTIONS, { value: Number(today.getMonth() + 1)}); // starts at 0 so +1
const year = lodash.find(YEAR_OPTIONS, { value: Number(today.getFullYear())});

const initialState = {
    billingRecords: [],
    selectedYear: {label: year.label, value: year.value},
    selectedMonth: {label: month.label, value: month.value},
}

const ManualEntryBillingRecordsReducer = (state = initialState, action) => {
    switch (action.type) {

        case ManualEntryRecordActionTypes.SET_YEAR: {
            let newState = _.cloneDeep(state);
            if (action.payload !== null) {
                newState.selectedYear = action.payload;
                newState.billingRecords = initialState.billingRecords;
            } else {
                newState.selectedYear = initialState.selectedYear;
                newState.billingRecords = initialState.billingRecords;
            }
            return newState;
        }

        case ManualEntryRecordActionTypes.SET_MONTH: {
            let newState = _.cloneDeep(state);
            if (action.payload !== null) {
                newState.selectedMonth = action.payload;
                newState.billingRecords = initialState.billingRecords;
            } else {
                newState.selectedMonth = initialState.selectedMonth;
                newState.billingRecords = initialState.billingRecords;
            }
            return newState;
        }

        case ManualEntryRecordActionTypes.SET_RECORDS: {
            let newState = _.cloneDeep(state);
            newState.billingRecords = action.payload;
            return newState;
        }

        case ManualEntryRecordActionTypes.CLEAR_MANUAL_BILLING_RECORDS: {
            return initialState;
        }

        default: return state
    }
}

export default ManualEntryBillingRecordsReducer;
